(function() { window.GUID_1c6e36b4_b445_4a5c_947a_48f43a3076e1 = { getGuid: function() { return "1c6e36b4-b445-4a5c-947a-48f43a3076e1"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.ControlBase.BaseEvents.ControlBaseLoaded(CS.Controls.Accordion, {
                        selector: "body",
                        childSelector: ".accordion-messages",
                        //context: null,
                        callback: function (control, e) {
                            const isWallLayout = $(`#wall-layout-${control.ContentId}`).val() == "true";
                            const markAllAsReadButton = $(`#button-mark-all-as-read-${control.ContentId}`);
                            if (markAllAsReadButton.length) {
                                markAllAsReadButton.offon("click.markallasread", function (e) {
                                    const { url } = markAllAsReadButton.data("html");
                                    if (url != null) {
                                        CS.Ajax.Post(url, {}, function (count) {
                                            CS.Nav.Refresh();
                                        });
                                    }
                                });
                            }
                            control.$Container.offon("click.messages", ".message-box", function (e) {
                                let $target = $(e.target);
                                let $messageBox = $(this);
                                if (!$messageBox.hasClass("message-box")) {
                                    $messageBox = $messageBox.closest(".message-box");
                                }
                                if ($target.hasClass("dismiss")) {
                                    markAsRead($messageBox);
                                }
                                else if ($messageBox.hasClass("is-new")) {
                                    if (isWallLayout) {
                                        onNewMessagesClicked($messageBox, control.ContentId);
                                    }
                                }
                                else {
                                    showHideButtons($(this));
                                }
                            });
                            control.$Container.offon("click.exclude-team", ".button-exclude-team", function (e) {
                                let $target = $(e.target);
                                let $messageBox = $(this);
                                let oppid = $(this).data("entitybaseid");
                                if (!$messageBox.hasClass("message-box")) {
                                    $messageBox = $messageBox.closest(".message-box");
                                }
                                removeAllMsgFromTeam(oppid);
                            });
                            if (isWallLayout) {
                                CS.DOM.$body.offon("newmessagereceived.messages", function () {
                                    onNewMessagesReceived(control.ContentId);
                                });
                            }
                            CS.DOM.$body.offon("click.newPlayerAdded", ".button-trigger-events-linker", (e) => {
                                let shouldOfferToNavigateToEvent = false;
                                const $button = $(e.currentTarget);
                                const { SportEventId, ConfirmationPopupUrl } = $button.data("html");
                                const $messageBox = $button.closest(".message-box");
                                if (SportEventId) {
                                    CS.Controls.Popup.ShowAjaxModal("/eventslinker/EventsLinkerUnidentifiedEventsOnlyModal", {
                                        overrideSportEventId: SportEventId,
                                    }, ({ popup: p, isPopup }) => {
                                        if (!isPopup) {
                                            return;
                                        }
                                        p.$Control.offon("click.eventsliknerpopupyesbuttonclicked", ".yes-button", (e) => {
                                            p.Proceed = true;
                                            shouldOfferToNavigateToEvent = true;
                                            CS.Lag("EventsLinkerDelayBeforeClosingPopup", 250, () => {
                                                p.Close();
                                            });
                                        });
                                        p.$Control.offon("click.eventsliknerpopupnobuttonclicked", ".no-button", (e) => {
                                            p.Proceed = true;
                                            CS.Lag("EventsLinkerDelayBeforeClosingPopup", 250, () => {
                                                p.Close();
                                            });
                                        });
                                    }, ({ popup: p }) => {
                                        if (p.Proceed) {
                                            $messageBox.find(".dismiss").click();
                                            if (shouldOfferToNavigateToEvent) {
                                                if (!CS.Helper.isNullOrWhiteSpace(ConfirmationPopupUrl)) {
                                                    CS.Lag("EventsLinkerDelayBeforeAskingToNavigate", 500, () => {
                                                        CS.Controls.Popup.ShowAjaxModal(ConfirmationPopupUrl, {}, (p) => { }, (p) => { }, true);
                                                    });
                                                }
                                            }
                                        }
                                    }, true);
                                }
                            });
                        },
                    });
                    function markAsRead($message) {
                        let removeElement = CS.CommonData.Current.Navigation.Action != "all";
                        let data = {
                            id: $message.attr("id").replace("m-", ""),
                            fromMarkAsReadButton: true,
                        };
                        CS.Ajax.Post(CS.Url.CSUrl("markasread"), data, function (count) {
                            if (removeElement) {
                                $message.hide("slide", { direction: "left" }, 500, function () {
                                    let $messageGroup = $message.closest(".message-group");
                                    $message.remove();
                                    removeEmptyMessageGroup($messageGroup);
                                    refreshItemsCount(count);
                                });
                            }
                            else {
                                $message.addClass("is-dismissed");
                                showHideButtons($message);
                                refreshItemsCount(count);
                            }
                        });
                    }
                    function removeEmptyMessageGroup($messageGroup) {
                        if ($messageGroup.length === 0) {
                            return;
                        }
                        if ($messageGroup.find(".message-box").length === 0) {
                            $messageGroup.hide("slide", { direction: "left" }, 500, function () {
                                $messageGroup.remove();
                            });
                        }
                    }
                    function removeAllMsgFromTeam(oppid) {
                        let teamId = oppid;
                        let isSubscribed = false;
                        let data = {
                            teamId: teamId,
                            isSubscribed: isSubscribed,
                        };
                        CS.Ajax.Post($("#csurl-updateteamnotificationsubscription").val(), data, function (response) {
                            CS.Nav.Refresh();
                        });
                    }
                    function refreshItemsCount(itemsCount = null) {
                        CS.Views.MasterPage.Instance.RefreshUnreadMessagesCount(itemsCount, (response) => { });
                    }
                    function onNewMessagesReceived(accordionId) {
                        var latmessid = $(`#last-message-id-${accordionId}`);
                        if (latmessid != null && latmessid.length > 0) {
                            var data = {
                                lastMessageId: latmessid.val(),
                            };
                            if (data.lastMessageId != null) {
                                CS.Ajax.Get(CS.Url.CSUrl("getlatestmessages"), data, function (response) {
                                    let $messagesContainer = $("#messages-container");
                                    if ($messagesContainer.length > 0 && response != "") {
                                        $messagesContainer.find("#new-messages").remove();
                                        const $response = $(`<div>${response}</div>`);
                                        $response.find(".message-box:not(.is-new)").remove();
                                        $messagesContainer.prepend($response);
                                    }
                                });
                            }
                        }
                    }
                    function showHideButtons($messageBox) {
                        $messageBox.toggleClass("expanded");
                    }
                    function onNewMessagesClicked($clickedBox, accordionId) {
                        const refreshUrl = $(`#refresh-with-reset-url-${accordionId}`).val();
                        if (refreshUrl != null) {
                            CS.Nav.Go(refreshUrl.toString());
                        }
                    }
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=messages.js.map
